import { render } from "./LeagueTrend.vue?vue&type=template&id=315e09ff&scoped=true"
import script from "./LeagueTrend.vue?vue&type=script&lang=js"
export * from "./LeagueTrend.vue?vue&type=script&lang=js"

import "./LeagueTrend.vue?vue&type=style&index=0&id=315e09ff&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315e09ff"]])

export default __exports__